import React, { useState } from 'react'
import { BeamDesignerWorkspace } from '@structura/beam-analysis'
import { ShareEditor } from '@structura/sharing'
import { sharingClient } from '../../sharing.config'

/**
 * Steel beam designer page (/beam/steel).
 *
 * Independent page shell composing the shared analysis workspace. Steel-specific
 * panels and integrations belong on this page as the apps diverge.
 */
const SteelBeam: React.FC = () => {
  const [sharing, setSharing] = useState<{ id: string; name: string } | null>(null)
  return (
    <>
      <BeamDesignerWorkspace material="steel" onShareDesign={setSharing} />
      {sharing && (
        <ShareEditor
          client={sharingClient}
          resourceType="beam-design"
          resourceId={sharing.id}
          title={sharing.name}
          onClose={() => setSharing(null)}
        />
      )}
    </>
  )
}

export default SteelBeam
